import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { Subscription, Payment, StripeClientSecretResponse } from '../../Types/stripe';
import { buildUrl } from '../../Utils/Api';
import { CreateChatUserRequest, GetChatTokenResponse, GetChatUsersResponse } from '../../Types/Chat';
import { AppSettings } from '../../Utils/Settings';

const base = 'chat'
export const chatApi = createApi({
    reducerPath: 'chatApi',
    baseQuery: fetchBaseQuery({
        baseUrl: AppSettings.ApiBaseUrl,
        prepareHeaders: async (headers, {getState}) =>{
            headers.set(
                'Authorization',
                `Bearer ${(localStorage.getItem('token') ?? '')}`
            );
            return headers;
        }
    }),
    tagTypes: ['ChatUsers'],
    endpoints: (builder) => ({
        GetChatToken: builder.query<GetChatTokenResponse, void>({
            query: () => ({
                url: buildUrl(base, `token`),
                method: "GET"
            })
        }),
        GetChatUsers: builder.query<GetChatUsersResponse, void>({
            providesTags: ['ChatUsers'],
            query: () => ({
                url: buildUrl(base, `users`),
                method: "GET"
            })
        }),
        CreateChatUser: builder.mutation<void, CreateChatUserRequest>({
            query: (body) => ({
                url: buildUrl(base, `user`),
                method: "POST",
                body
            })
        })
    }),
})

export const {
    useGetChatUsersQuery,
    useCreateChatUserMutation,
    useGetChatTokenQuery
} = chatApi